import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Dashboard from "../../components/AuditAI/Dashboard";
import Navbar from "../../components/Navbar/Navbar";
import "./Console.css";

function Console() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    // Check if the Stripe redirect URL contains ?signup=success
    if (searchParams.get("signup") === "success") {
      setShowSuccessModal(true);
      // Clean up the URL parameters so the modal doesn't re-trigger on reload
      setSearchParams({}, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return (

    <>
    <div className="console-layout">
      <Navbar />



      <Dashboard />
    </div>
      {/* SECURE MVELIO SUBSCRIPTION SUCCESS OVERLAY */}
      {showSuccessModal && (
        <div className="overlay">
          <div className="card">
            <div className="icon">🎉</div>
            <h2  className="title">Welcome to Mvelio Premium!</h2>
            <p className="text">
              Your subscription is active and your real-time telemetry log monitoring is now fully powered up.
            </p>
            <button 
              className="button" 
              onClick={() => setShowSuccessModal(false)}
              onMouseEnter={(e) => (e.target.style.opacity = "0.9")}
              onMouseLeave={(e) => (e.target.style.opacity = "1")}
            >
              Enter Console
            </button>
          </div>
        </div>
      )}</>    
  );
}


export default Console;
